import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';

import { AppState } from '../../app.state';
import { map } from 'rxjs/operators';

export const anonymousGuard: CanMatchFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(AppState.isAuthenticated)
              .pipe(
                  map((auth) => auth
                                ? router.createUrlTree(['/'])
                                : true),
              );
};
